import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    language:'fr',
    isMobile:false,
    screenWidth:0,
    scrollTop:0,
    config:{}
  },
  getters: {
    language: state => {
      const language = localStorage.getItem('language')?localStorage.getItem('language'):state.language
      return language
    },
    config: state => {
      const config = localStorage.getItem('config')?JSON.parse(localStorage.getItem('config')):state.language
      return config
    },
    scrollTop:state => {
      return state.scrollTop
    },
    isMobile:state => {
      const isMobile = state.screenWidth>768?false:true
      return isMobile
    },
  },
  mutations: {
    setLanguage (state, res) {
      state.language = res
      localStorage.setItem('language', res)
    },
    setConfig (state, res) {
      state.config = res
      localStorage.setItem('config', JSON.stringify(res))
    },
    setScreenWidth (state, res) {
      state.screenWidth = res
    },
    setScrollTop (state, res) {
      state.scrollTop = res
    },
  },
  actions: {},
  modules: {},
});
